import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { Topic } from './forum/topic';

@Injectable({
  providedIn: 'root'
})
export class TopicService {
  private api = inject(TslApiService);

  getTopic(id: string): Observable<Topic> {
    return this.api.get('topic', { id });
  }
}
